module.exports = __webpack_public_path__ + "static/media/19ESCAP3.2715f4cb.jpg";